module.exports = __webpack_public_path__ + "static/media/used10.c01dee5f.JPG";